import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { Subject } from 'rxjs'

import { KeyNodeTitle, KeyNodeType } from '@overtur-monorepo/keying-shared'
import { MasterKeyService } from '../../services/keying.masterkey.service'
import { take } from 'rxjs/operators'

@Component({
    selector: 'app-thru-notation-dialog',
    templateUrl: './thru-notation-dialog.component.html',
    styleUrls: ['./thru-notation-dialog.component.scss'],
    standalone: false
})
export class ThruNotationDialogComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  keyNodeType = KeyNodeType
  thruForm: FormGroup

  selectiveData: any
  lasSKD

  skipErrors = false
  max = 1

  focus = {
    prefix: false,
    from: false,
    to: false,
    suffix: false,
  }

  public errorMessages = {
    prefix: [
      { type: 'required', message: 'Prefix is required.' },
      { type: 'beginsWithX', message: 'Can not start with X.' },
    ],
    from: [{ type: 'required', message: 'From is required.' }],
    to: [{ type: 'required', message: 'To is required.' }],
    suffix: [{ type: 'required', message: 'Suffix is required.' }],
  }

  prefix = ''

  constructor(
    public form: FormBuilder,
    private dialogRef: MatDialogRef<ThruNotationDialogComponent>,
    private masterKeyService: MasterKeyService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectiveData = data

    if (this.validate()) {
      this.setPrefix()
      this.createForm()

      if (this.selectiveData.masterKey.masterKeyTypeId === this.keyNodeType.SingleKeyDifferentMaster) {
        this.getLastSKD()
      }
    }
  }

  validate() {
    if (!this.selectiveData) return false
    if (!this.selectiveData.action) return false
    return true
  }

  setPrefix(): void {
    switch (this.selectiveData.action) {
      case KeyNodeTitle.CHANGE_KEYS:
        this.prefix = this.changeKeyPrefix
        break
      default:
        this.prefix = ''
        break

      // case KeyNodeTitle.MASTER_KEYS:
      //   this.prefix = this.selectiveData.masterKey.keySetSymbol
      //   break
      // case KeyNodeTitle.DELETE_KEYS:
      //   this.prefix = this.changeKeyPrefix
      //   break
    }
  }

  get changeKeyPrefix(): string {
    const masterKeyTypeId = this.selectiveData.masterKey.masterKeyTypeId

    if (masterKeyTypeId === KeyNodeType.SingleKeyDifferentMaster) {
      return KeyNodeTitle.SKD
    } else {
      return ''
    }

    // return masterKeyTypeId === KeyNodeType.SingleKeyDifferentMaster
    //   ? KeyNodeTitle.SKD
    //   : masterKeyTypeId === KeyNodeType.DirectChangeMaster
    //   ? this.selectiveData.masterKey.parent.keySetSymbol
    //   : this.selectiveData.masterKey.keySetSymbol
  }

  /* istanbul ignore next */
  createForm(): void {
    this.thruForm = this.form.group({
      prefix: new FormControl(
        {
          value: this.prefix,
          disabled: this.prefix === KeyNodeTitle.SKD,
        },
        [this.beginsWithXValidator]
      ),
      from: new FormControl('', [Validators.required]),
      to: new FormControl('', [Validators.required]),
      suffix: new FormControl({
        value: '',
        disabled: this.prefix === KeyNodeTitle.SKD,
      }),
      allowExclusions: new FormControl(false),
    })
  }

  /* istanbul ignore next */
  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  /* istanbul ignore next */
  ngOnInit() {
    this.setMax(this.selectiveData.action)
  }

  setMax(action) {
    switch (action) {
      case KeyNodeTitle.CHANGE_KEYS:
        this.max = 5
        break
      case KeyNodeTitle.MASTER_KEYS:
        this.max = 1
        break
      case KeyNodeTitle.DELETE_KEYS:
        this.max = 5
        break
      default:
        break
    }
  }

  /* istanbul ignore next */
  beginsWithXValidator = (control: FormControl) => {
    let value = control.value
    if (value !== '') {
      const beginsWithX = value.charAt(0).toUpperCase() === 'X'
      if (beginsWithX) {
        return { beginsWithX, type: 'beginsWithX' }
      }
    }
    return null
  }

  /* istanbul ignore next */
  displayName(subject) {
    if (subject.name) {
      return (subject && subject.name) || subject
    } else if (subject.description) {
      return (subject && subject.description) || subject
    }
  }

  /* istanbul ignore next */
  getLastSKD() {
    this.masterKeyService
      .getLastSKD(this.selectiveData.structure.id, this.selectiveData.keySystem.id)
      .pipe(take(1))
      .subscribe((lasSKD) => {
        this.lasSKD = lasSKD
      })
  }

  /* istanbul ignore next */
  submit() {
    if (this.thruForm.valid) {
      const data = {
        masterKey: this.selectiveData.masterKey,
        action: this.selectiveData.action,
        prefix: this.thruForm.controls.prefix.value,
        from: this.thruForm.controls.from.value,
        to: this.thruForm.controls.to.value,
        suffix: this.thruForm.controls.suffix.value,
        allowAllCharacters: this.thruForm.controls.allowExclusions.value,
      }

      this.dialogRef.close(data)
    }
  }

  /* istanbul ignore next */
  focusOn(focus) {
    this.focus[focus] = !this.focus[focus]
  }

  /* istanbul ignore next */
  fieldHasErrorMessages(form, validation, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.hasError(validation.type) && (field.dirty || field.touched))
  }

  /* istanbul ignore next */
  fieldHasError(form, fieldName) {
    const field = form.get(fieldName)

    return Boolean(field.invalid && (field.dirty || field.touched))
  }

  /* istanbul ignore next */
  close() {
    this.dialogRef.close()
  }
}
